import { combineReducers } from 'redux';

import changeStatusReducer from './change-status/reducer';
import changeUserReducer from './change-user/reducer';
import customerProfileReducer from './customer-profile/reducer';
import eventsReducer from './events/reducer';
import forgotPasswordReducer from './forgot-password/reducer';
import statusListReducer from './get-status/reducer';
import supplementaryServiceReducer from './get-supplementary-service/reducer';
import ticketByIdReducer from './get-ticket-by-id/reducer';
import userListReducer from './get-user-list/reducer';
import loginReducer from './login/reducer';
import ticketsReducer from './my-tickets/reducer';
import changeNirReducer from './post-change-nir/reducer';
import changeSupplementaryServiceReducer from './post-supplementary-service/reducer';
import changeSimReducer from './request-change-sim/reducer';
import commentTiketsReducer from './request-comments-tickets/reducer';
import nirReducer from './request-get-nir/reducer';
import getActionImeiReducer from './request-imei/reducer';
import incidenceCategoryReducer from './request-incidence-category/reducer';
import incidenceChannelReducer from './request-incidence-channel/reducer';
import incidenceReducer from './request-incidence/reducer';
import listCommentTicketsReducer from './request-list-comments/reducer';
import lockImeiReducer from './request-lock-imei/reducer';
import resumeLineActionReducer from './request-resume-line/reducer';
import actionSuspendLineReducer from './request-suspend-line/reducer';
import actionPostUnbarringActionReducer from './request-unbarring-action/reducer';
import unlockImeiReducer from './request-unlock-imei/reducer';
import actionPostUpdateApnReducer from './request-upadate-apn/reducer';
import resetPasswordReducer from './reset-password/reducer';
import resetPasswordStatusReducer from './reset-password/statusReducer';
import actionPostBarringActionReducer from './resuqest-barring-action/reducer';
import ticketsByNumberReducer from './tickets-by-number/reducer';

import leadReducer from './lead/reducer';
import leadsReducer from './leads/reducer';
import portabilityReducer from './portability/reducer';

import linksReducer from './links/reducer';

import municipalityReducer from './sepomex-municipality/reducer';
import neighborhoodReducer from './sepomex-neighborhood/reducer';

import checkImeiReducer from './check-imei/reducer';
import offersReducer from './offers/reducer';

import backofficeLeadStatusReducer from './backoffice-lead-status/reducer';
import backofficeStatusReducer from './backoffice-status/reducer';

import putLeadReducer from './put-lead/reducer';

import checkPaymentStatusReducer from './get-check-payment-status/reducer';

import leadAssignmentReducer from './lead-assignment/reducer';

import leadsByCampaingReducer from './leads-by-campaing/reducer';
import ordersByProductReducer from './orders-by-product/reducer';

import getCampaingReducer from './get-campaing/reducer';
import getChannelReducer from './get-channel/reducer';

import campaignChannelReducer from './campaign-channel/reducer';

import channelCreatedLeadReducer from './channel-lead/reducer';

import createLeadReducer from './create_lead/reducer';

import patchLeadReducer from './patch-lead/reducer';

import landingListReducer from './get-landing_list/reducer';

import leadStatusListObjReducer from './get-lead-status-list/reducer';

import activationsAndDeactivationsReducer from './get-activations-and-deactivations/reducer';

import prepaidByDayReducer from './get-prepaid-by-date-kpi/reducer';

import prepaidByProductReducer from './get-prepaid-by-product-kpi/reducer';

import saleOrdersReducer from './sales-orders/reducer';

import createIncidenceReducer from './create_incidence/reducer';
import saleOrderDetailReducer from './sales-detail-order/reducer';

import saleOrderEsimQrReducer from './esim-qr/reducer';
import generalTicketsReducer from './tickets/reducer';

import mySalesExecutiveDetailsReducer from './my-sales-detail-executive/reducer';
import mySalesDetailsReducer from './my-sales-details/reducer';
import mySalesReducer from './my-sales/reducer';
import mySalesExecutiveReducer from './reports-executive/reducer';

import ConsultingcheckImeiReducer from './consulting-imei/reducer';
import consultingCheckZipcodeReducer from './consulting-zipcode/reducer';
import dailyRefillsPerProductReducer from './kpi_daily_refills_per_product/reducer';
import postBindAssistedOrderReducer from './post-bind-assisted-order/reducer';
import prepaidsBySubDistributorReducer from './total-prepaids-by-sub-distributor/reducer';

import getContactPhoneReducer from './contact-phone-report/reducer';
import getEmailReportReducer from './email-report/reducer';
import getSalesDailyReducer from './get-sales-daily/reducer';
import getSalesMonthlyReducer from './get-sales-monthly/reducer';
import getSalesWeeklyReducer from './get-sales-weekly/reducer';
import ipRestrictionReducer from './ip-restriction/reducer';

import changeEsimToSimReducer from './change-esim-sim/reducer';
import changeSimToEsimReducer from './change-sim-esim/reducer';
import detailTransferSalesReducer from './detail-transfer-sales/reducer';
import listTransferSalesReducer from './list-transfer-sales/reducer';
import offersForSimPurchaseReducer from './offers-for-sim-purchase/reducer';
import processTransferSalesReducer from './process-transfer-sales/reducer';
import transferSalesReducer from './transfer-sales/reducer';

import getGiftOrdersDetailReducer from './gift-orders/get-gift-orders-detail/getGiftOrdersDetailReducer';
import getGiftOrdersReducer from './gift-orders/get-gift-orders/getGiftOrdersReducer';

import detailTransactionsNetpayReducer from './detail-transactions-netpay/reducer';
import detailsTransactionsSTPReducer from './detail-transactions-stp/reducer';
import netPayReducer from './list-transactions-netpay/reducer';
import listTransactionsSTPReducer from './list-transfer-stp/reducer';
import rechargeHistoryReducer from './recharge-history/reducer';
import simActivationReducer from './sim-activation/reducer';

import addLineReducer from './add-line/reducer';
import purchaseDetailsAiraloReducer from './airalo-purchase-details/reducer';
import atnPortability from './atn-portability/reducer';
import orderAssignmentConfirmUploadDocumentReducer from './confirm-upload-assignment-document/reducer';
import consultLegalIdReducer from './consult-legal-id/reducer';
import createIncodeLinksReducer from './create-incode-links/reducer';
import createOrderLineAssignmentReducer from './create-order-line-assignment/reducer';
import orderAssignmentCreateUrlDocumentReducer from './create-url-upload-assignment-document/reducer';
import detailFreeTrialIpbReducer from './detail-free-trial-ipb/reducer';
import detailGiftSimIpbReducer from './detail-gift-sim-ipb/reducer';
import detailListSimIpbReducer from './detail-list-sim-ipb/reducer';
import detailTransactionChargebackReducer from './detail-transaction-chargeback/reducer';
import detailTransactionFraudReducer from './detail-transaction-fraud/reducer';
import PrepaidChargebackReducer from './detail-transaction-prepaid-chargeback/reducer';
import PrepaidFraudReducer from './detail-transaction-prepaid-fraud/reducer';
import detailTransactionsMercadoPagoReducer from './detail-transactions-mercadopago/reducer';
import detailTransactionsOpenpayReducer from './detail-transactions-openpay/reducer';
import detailTransactionsStripeReducer from './detail-transactions-stripe/reducer';
import detailsTransactionsTokuReducer from './detail-transactions-toku/reducer';
import detailTransactionsYunoReducer from './detail-transactions-yuno/reducer';
import directoryStoreExistsReducer from './directory-stores-exists/reducer';
import directoryStoreOmvsReducer from './directory-stores-omvs/reducer';
import downloadPdfReducer from './download-pdf/reducer';
import downloadPortabilityFileReducer from './download-portability-files/reducer';
import editStoresReducer from './edit-mtc-id/reducer';
import emailFreeTrialIpbReducer from './email-free-trial-ipb/reducer';
import simGiftOrdersReducer from './email-sim-gift-ipb/reducer';
import failedTransactionsListIpbReducer from './failed_transactions_ipb_list/reducer';
import failedTransactionsListDetailsIpbReducer from './failed_transactions_ipb_list_details/reducer';
import {
  flowsVinculationFilterReducer,
  statusVinculationFilterReducer,
  typeVinculationFilterReducer,
} from './filter_order_vinculation/reducer';
import listFreeTrialIpbReducer from './free-trial-list-ipb/reducer';
import postGenerateInvoicesReducer from './generate-invoice/reducer';
import getIncodeStatusReducer from './get-incode-status/reducer';
import orderAssignmentDetailReducer from './get-order-detail/reducer';
import ordersAssignmentsReducer from './get-orders-assignments/reducer';
import listGiftSimIpbReducer from './gift-sim-list-ipb/reducer';
import ipbDirectoryModerationReducer from './handle-store-moderation/reducer';
import iftReportReducer from './ift-report/reducer';
import ipbDirectoryDetailReducer from './ipb-directory-detail/reducer';
import ipbDirectoryListingReducer from './ipb-directory-listing/reducer';
import ipbInvoiceListReducer from './ipb-invoice-list/reducer';
import ipbDirectoryModerationDetailReducer from './ipb-moderacion-detail/reducer';
import ipbDirectoryModerationListingReducer from './ipb-moderacion-listing/reducer';
import ipbPackageByChannelReducer from './ipb-package-by-channel/reducer';
import editLegalDataReducer from './legal-Data-edit/reducer';
import listSimIpbReducer from './list-ipb/reducer';
import mercadoPagoReducer from './list-transactions-mercadopago/reducer';
import openpayReducer from './list-transactions-openpay/reducer';
import stripeReducer from './list-transactions-stripe/reducer';
import listTransactionsTokuReducer from './list-transactions-toku/reducer';
import yunoReducer from './list-transactions-yuno/reducer';
import makePrepaidReducer from './makePrepaid/reducer';
import neighborhoodLocationReducer from './neighborhood-location/reducer';
import orderVinculationListReducer from './order_vinculation_list/reducer';
import orderVinculationDetailListReducer from './order_vinculation_list_details/reducer';
import orderVinculationSessionsDetailReducer from './order_vinculation_sessions_details/reducer';
import changeZoneReducer from './post-change-zone/reducer';
import iccUnlockingReducer from './post-icc-unlocking/reducer';
import preRegisterGiftSimDalefonReducer from './pre-register-gift-sim-dalefon/reducer';
import prepaidReducer from './prepaid-history/reducer';
import productsPrepaid from './products_prepaid/reducer';
import purchaseOrderListIpbReducer from './purchase_order_list/reducer';
import purchaseOrderListDetailsIpbReducer from './purchase_order_list_details/reducer';
import registeredStoresReducer from './register-mtc-id/reducer';
import removeAssignmentDocumentReducer from './remove-assignment-document/reducer';
import removeLineReducer from './remove-line/reducer';
import reportTransactionsChargebackReducer from './report-transaction-chargeback/reducer';
import reportTransactionsFraudReducer from './report-transaction-fraud/reducer';
import updateOrderLineAssignmentReducer from './update-order-line-assignment/reducer';
import orderAssignmentUploadDocumentReducer from './upload-assignment-document/reducer';
import zipCodeAddressStoreReducer from './zipcode-address-store/reducer';

export default combineReducers({
  login: loginReducer,
  forgotPassword: forgotPasswordReducer,
  customerProfile: customerProfileReducer,
  resetPassword: resetPasswordReducer,
  resetPasswordStatus: resetPasswordStatusReducer,
  ticketsReducer: ticketsReducer,
  ticketsByNumber: ticketsByNumberReducer,
  incidence: incidenceReducer,
  incidenceCategory: incidenceCategoryReducer,
  incidenceChannel: incidenceChannelReducer,
  commentTikets: commentTiketsReducer,
  listCommentTickets: listCommentTicketsReducer,
  actionPostUpdateApn: actionPostUpdateApnReducer,
  actionPostBarringAction: actionPostBarringActionReducer,
  actionPostUnbarringAction: actionPostUnbarringActionReducer,
  actionSuspendLine: actionSuspendLineReducer,
  getActionImei: getActionImeiReducer,
  events: eventsReducer,
  lockImei: lockImeiReducer,
  unlockImei: unlockImeiReducer,
  supplementaryService: supplementaryServiceReducer,
  changeSupplementaryService: changeSupplementaryServiceReducer,
  nir: nirReducer,
  changeSim: changeSimReducer,
  changeNir: changeNirReducer,
  changeZone: changeZoneReducer,
  statusList: statusListReducer,
  changeStatusTicket: changeStatusReducer,
  userList: userListReducer,
  changeUser_: changeUserReducer,
  ticketById: ticketByIdReducer,
  resumeLineAction: resumeLineActionReducer,
  portability: portabilityReducer,
  lead: leadReducer,
  leads: leadsReducer,
  prepaidFraud: PrepaidFraudReducer,
  prepaidChargeback: PrepaidChargebackReducer,
  links: linksReducer,

  municipality: municipalityReducer,
  neighborhood: neighborhoodReducer,
  offers: offersReducer,
  checkImei: checkImeiReducer,
  backofficeLeadStatus: backofficeLeadStatusReducer,
  backofficeStatus: backofficeStatusReducer,
  putLead: putLeadReducer,

  prepaidByDay: prepaidByDayReducer,

  prepaidByProduct: prepaidByProductReducer,

  checkPaymentStatus: checkPaymentStatusReducer,

  leadAssignment: leadAssignmentReducer,

  leadsByCampaing: leadsByCampaingReducer,
  ordersByProduct: ordersByProductReducer,

  activationsAndDeactivation: activationsAndDeactivationsReducer,

  getCampaingObj: getCampaingReducer,

  getChannelObj: getChannelReducer,

  campaignChannel: campaignChannelReducer,

  channelCreatedLead: channelCreatedLeadReducer,

  createLeadObj: createLeadReducer,

  patchLeadObj: patchLeadReducer,

  landingListObj: landingListReducer,

  leadStatusListObj: leadStatusListObjReducer,

  saleOrders: saleOrdersReducer,

  createIncidenceObj: createIncidenceReducer,
  saleOrderDetail: saleOrderDetailReducer,
  generalTickets: generalTicketsReducer,

  saleOrderEsimQr: saleOrderEsimQrReducer,

  mySales: mySalesReducer,

  mySalesDetails: mySalesDetailsReducer,

  postBindAssistedOrder: postBindAssistedOrderReducer,
  mySalesExecutive: mySalesExecutiveReducer,
  mySalesExecutiveDetails: mySalesExecutiveDetailsReducer,

  dailyRefillsPerProduct: dailyRefillsPerProductReducer,
  prepaidsBySubDistributor: prepaidsBySubDistributorReducer,
  ConsultingcheckImei: ConsultingcheckImeiReducer,
  consultingCheckZipcode: consultingCheckZipcodeReducer,

  getSalesMonthly: getSalesMonthlyReducer,
  getSalesWeekly: getSalesWeeklyReducer,
  getSalesDaily: getSalesDailyReducer,

  getContactPhone: getContactPhoneReducer,
  getEmailReport: getEmailReportReducer,
  ipRestriction: ipRestrictionReducer,
  changeEsimToSim: changeEsimToSimReducer,
  changeSimToEsim: changeSimToEsimReducer,

  getGiftOrders: getGiftOrdersReducer,
  getGiftOrdersDetail: getGiftOrdersDetailReducer,

  transferSales: transferSalesReducer,
  ofersSimPurchase: offersForSimPurchaseReducer,
  listTransferSales: listTransferSalesReducer,
  detailTransferSales: detailTransferSalesReducer,
  processTransferSales: processTransferSalesReducer,
  netPay: netPayReducer,
  simActivation: simActivationReducer,
  detailTransactionsNetpay: detailTransactionsNetpayReducer,
  rechargeHistory: rechargeHistoryReducer,
  listTransactionsSTP: listTransactionsSTPReducer,
  detailsTransactionsSTP: detailsTransactionsSTPReducer,

  atnPortability: atnPortability,
  makePrepaid: makePrepaidReducer,
  productsPrepaid: productsPrepaid,
  listTransactionsToku: listTransactionsTokuReducer,
  detailsTransactionsToku: detailsTransactionsTokuReducer,

  detailTransactionFraud: detailTransactionFraudReducer,
  detailTransactionChargeback: detailTransactionChargebackReducer,
  reportTransactionsFraud: reportTransactionsFraudReducer,
  reportTransactionsChargeback: reportTransactionsChargebackReducer,
  orderVinculationList: orderVinculationListReducer,
  orderVinculationDetailList: orderVinculationDetailListReducer,
  orderVinculationSessionsDetail: orderVinculationSessionsDetailReducer,
  flowsVinculationFilter: flowsVinculationFilterReducer,
  statusVinculationFilter: statusVinculationFilterReducer,
  typeVinculationFilter: typeVinculationFilterReducer,
  purchaseOrderListIpb: purchaseOrderListIpbReducer,
  purchaseOrderListDetailsIpb: purchaseOrderListDetailsIpbReducer,
  failedTransactionsListIpb: failedTransactionsListIpbReducer,
  failedTransactionsListDetailsIpb: failedTransactionsListDetailsIpbReducer,
  listSimIpb: listSimIpbReducer,
  detailListSimIpb: detailListSimIpbReducer,
  listGiftSimIpb: listGiftSimIpbReducer,
  prepaid: prepaidReducer,
  detailGiftSimIpb: detailGiftSimIpbReducer,
  ipbInvoiceList: ipbInvoiceListReducer,
  generateInvoices: postGenerateInvoicesReducer,
  responseEditLegalData: editLegalDataReducer,
  listOpenpay: openpayReducer,
  detailTransactionsOpenpay: detailTransactionsOpenpayReducer,
  responseIpbDirectoryListing: ipbDirectoryListingReducer,
  responseIpbDirectoryDetail: ipbDirectoryDetailReducer,
  responseIpbDirectoryModerationListing: ipbDirectoryModerationListingReducer,
  responseIpbDirectoryModerationDetail: ipbDirectoryModerationDetailReducer,
  responseIpbDirectoryModeration: ipbDirectoryModerationReducer,
  responseRegisteredStores: registeredStoresReducer,
  responseEditStores: editStoresReducer,
  responseDirectoryStoreExists: directoryStoreExistsReducer,
  responseDirectoryStoreOmvsReducer: directoryStoreOmvsReducer,
  responseZipCodeAddressStoreReducer: zipCodeAddressStoreReducer,
  responseNeighborhoodLocation: neighborhoodLocationReducer,
  simGiftOrders: simGiftOrdersReducer,
  preRegisterSimGiftIpb: preRegisterGiftSimDalefonReducer,
  ipbPackageByChannel: ipbPackageByChannelReducer,
  listMercadoPago: mercadoPagoReducer,
  detailTransactionsMercadoPago: detailTransactionsMercadoPagoReducer,
  listStripe: stripeReducer,
  listYuno: yunoReducer,
  detailTransactionsStripe: detailTransactionsStripeReducer,
  detailTransactionsYuno: detailTransactionsYunoReducer,
  listFreeTrialIpb: listFreeTrialIpbReducer,
  detailFreeTrialIpb: detailFreeTrialIpbReducer,
  downloadPortabilityFile: downloadPortabilityFileReducer,
  iftReport: iftReportReducer,
  emailFreeTrialIpb: emailFreeTrialIpbReducer,
  iccUnlocking: iccUnlockingReducer,

  ordersAssignments: ordersAssignmentsReducer,
  orderAssignmentDetail: orderAssignmentDetailReducer,
  orderAssignmentUploadDocument: orderAssignmentUploadDocumentReducer,
  createOrderLineAssignment: createOrderLineAssignmentReducer,
  orderAssignmentCreateUrlDocument: orderAssignmentCreateUrlDocumentReducer,
  updateOrderLineAssignment: updateOrderLineAssignmentReducer,
  orderAssignmentConfirmUploadDocument: orderAssignmentConfirmUploadDocumentReducer,
  removeAssignmentDocument: removeAssignmentDocumentReducer,
  addLine: addLineReducer,
  removeLine: removeLineReducer,
  createIncodeLinks: createIncodeLinksReducer,
  getIncodeStatus: getIncodeStatusReducer,
  downloadPdf: downloadPdfReducer,
  consultLegalId: consultLegalIdReducer,
  responsePurchaseDetailsAiralo: purchaseDetailsAiraloReducer,
});
